const isLocal = process.env.NODE_ENV === 'development';

const fetchUrl = async (url, method) => {
  try {
    const response = await fetch(url, {
      method,
      mode: 'no-cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const getInitData = async () => {
  if (isLocal) {
    const jsonMenu = await import(
      '../data/initDataLocal.json'
    ).then(({ default: jsonMenu }) => {
      return jsonMenu;
    });
    return jsonMenu;
  }
  if (window.params) {
    return window.params;
  }
  const url = `${window.location.origin}${window.location.pathname}params`;
  return fetchUrl(url, 'GET');
};

export const getAudioSpeaker = async (text) => {
  const url = 'https://cms.i-gvs.com/cp/academy/api/speech/speech';
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `text=${text}`,
      mode: 'cors',
    });
    if (!response.ok) {
      throw new Error('Network ERROR');
    }
    return await response.blob();
  } catch (error) {
    console.log(error);
  }
};

const commentsPath = `comments-${window.location.pathname}`;

export const getComments = async () => {
  return new Promise((response) => {
    if (localStorage.getItem(commentsPath)) {
      const comments = JSON.parse(localStorage.getItem(commentsPath));
      response(comments);
    } else {
      localStorage.setItem(commentsPath, JSON.stringify([]));
      response([]);
    }
  });
  /*
  const url = `${window.location.origin}${window.location.pathname}comments`;
  return fetchUrl(url, 'GET');
  */
};

export const addComment = async (newComment) => {
  return new Promise((response, reject) => {
    const comments = JSON.parse(localStorage.getItem(commentsPath));
    if (comments.findIndex((comment) => comment.id === newComment.id) === -1) {
      comments.push(newComment);
      localStorage.setItem(commentsPath, JSON.stringify(comments));
      response();
    } else {
      reject();
    }
  });
  /*
  const url = `${window.location.origin}${window.location.pathname}comments`;
  return fetchUrl(url, 'POST');
  */
};

export const removeComment = async (commentId) => {
  return new Promise((response) => {
    if (localStorage.getItem(commentsPath)) {
      const comments = JSON.parse(localStorage.getItem(commentsPath));
      const filteredComments = comments.filter((favorite) => favorite.id !== commentId);
      localStorage.setItem(commentsPath, JSON.stringify(filteredComments));
      response(filteredComments);
    }
  });
  /*
  const url = `${window.location.origin}${window.location.pathname}comments`;
  return fetchUrl(url, 'GET');
  */
};

const favoritesPath = `favorites-${window.location.pathname}`;

export const addFavorites = async (title, moduleId) => {
  return new Promise((response, reject) => {
    const favorites = JSON.parse(localStorage.getItem(favoritesPath));
    if (favorites.findIndex((favorite) => favorite.id === moduleId) === -1) {
      favorites.push({ title, id: moduleId });
      localStorage.setItem(favoritesPath, JSON.stringify(favorites));
      response();
    } else {
      reject();
    }
  });
};

export const getFavorites = async () => {
  return new Promise((response) => {
    if (localStorage.getItem(favoritesPath)) {
      const favorites = JSON.parse(localStorage.getItem(favoritesPath));
      response(favorites);
    } else {
      localStorage.setItem(favoritesPath, JSON.stringify([]));
      response([]);
    }
  });
};

export const removeFavorites = async (moduleId) => {
  return new Promise((response) => {
    if (localStorage.getItem(favoritesPath)) {
      const favorites = JSON.parse(localStorage.getItem(favoritesPath));
      const filteredFavorites = favorites.filter((favorite) => favorite.id !== moduleId);
      localStorage.setItem(favoritesPath, JSON.stringify(filteredFavorites));
      response(filteredFavorites);
    }
  });
};
